import axios from '@/utils/edu_request'
import qs from 'qs'
// 图书首页列表
export function getBookList(params) {
  return axios({
    url: '/home/textbook/getBookList',
    method: 'get',
    params
  })
}
// 判断课程是否购买
export function getIsBuy(params) {
  return axios({
    url: 'textbook/textbook/getIsBuy',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 请求课程列表接口
export function getLessonList(params) {
  return axios({
    url: 'lesson/Lessonlist',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 请求课程信息接口
export function getLesson(params) {
  return axios({
    url: '/lesson/lesson/getLesson',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 全部问答
export function QaAll(params) {
  return axios({
    url: '/qa/index/all',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 我的提问
export function Qame(params) {
  return axios({
    url: '/qa/index/question',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 我的回答
export function Qamyreply(params) {
  return axios({
    url: '/qa/index/answer',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 提问
export function saveQa(params) {
  return axios({
    url: '/qa/index/make',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 回复
export function reply(params) {
  return axios({
    url: '/qa/index/reply',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// seeMore changeStatus
export function seeMore(params) {
  return axios({
    url: '/qa/index/more',
    dataType: 'json',
    method: 'GET',
    params

  })
}
//  changeStatus
export function changeStatus(params) {
  return axios({
    url: '/qa/index/read',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 已购列表seeMore
export function buylist(params) {
  return axios({
    url: '/qa/index/have',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 课表
export function getScheduleByLessonId(params) {
  return axios({
    url: '/lesson/lesson/getScheduleByLessonId',
    method: 'get',
    params
  })
}

// 请求课程详情接口
export function getTextbook(params) {
  return axios({
    url: 'textbook/textbook/getTextbook',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 课程评价列表
export function getUserComment(params) {
  return axios({
    url: 'lesson/lesson/getUserComment',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 满意度调查
export function saveSatisfaction(params) {
  return axios({
    url: 'lesson/lesson/saveSatisfaction',
    method: 'post',
    contentType: 'application/x-www-from-urlencoded',
    data: qs.stringify(params)
  })
}
// 获取满意度查询结果
export function getSatisfaction(params) {
  return axios({
    url: 'lesson/lesson/getSatisfaction',
    method: 'get',
    params
  })
}
// 课程评价列表
export function get_evaluate(params) {
  return axios({
    url: 'lesson/lesson/getUserComment',
    dataType: 'json',
    method: 'GET',
    params

  })
}

// 提交评价
export function addComment(params) {
  return axios({
    url: 'lesson/lesson/addComment',
    dataType: 'json',
    method: 'GET',
    params

  })
}

// 产品评价标签
export function getVipCardCollection(params) {
  return axios({
    url: 'lesson/lesson/getCommentTag',
    method: 'get',
    params: params
  })
}

// 教育首页SEO
export function getRow(params) {
  return axios({
    url: '/setting/seo/getRow',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 销售策略
export function getBookStategyById(params) {
  return axios({
    url: '/lesson/lesson/getBookStategyById',
    method: 'get',
    params
  })
}
// 删除问答|回复
export function delQa(params) {
  return axios({
    url: 'qa/index/operate',
    method: 'get',
    params
  })
}

// 课表试卷 获取弹窗信息
export function getEvaluationInfo(params) {
  return axios({
    url: 'lesson/lesson/getEvaluationInfo',
    method: 'get',
    params
  })
}
// 问答编辑
export function edlQa(params) {
  return axios({
    url: 'qa/index/edit',
    method: 'post',
    data: params
  })
}
// 领取免费课程
export function saveUserLessonFree(params) {
  return axios({
    url: 'lesson/lesson/saveUserLessonFree',
    method: 'get',
    params
  })
}

// 获取直播满意度的信息
export function getLiveSatisfaction(params) {
  return axios({
    url: '/lesson/lesson/getLiveSatisfaction',
    method: 'get',
    params
  })
}
// 提交直播满意度
export function setLiveSatisfaction(params) {
  return axios({
    url: '/lesson/lesson/setLiveSatisfaction',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 获取推荐产品
export function lessonRecommendList(params) {
  return axios({
    url: 'lesson/lesson/lessonRecommendList',
    dataType: 'json',
    method: 'GET',
    params

  })
}
// 收藏和取消收藏
export function collectLesson(params) {
  return axios({
    url: '/lesson/lesson/collectLesson',
    method: 'get',
    params
  })
}
// 判断课程是否已经收藏
export function getCollectByUid(params) {
  return axios({
    url: 'lesson/lesson/getCollectByUid',
    method: 'get',
    params
  })
}
// 获取选中规格产品价格
export function getLessonSpecPrice(params) {
  return axios({
    url: 'lesson/lesson/getLessonSpecPrice',
    method: 'get',
    params
  })
}
// 获取拼团
export function pintuanList(params) {
  return axios({
    url: '/groupon/Details',
    method: 'GET',
    params
  })
}
// 立即购买检测库存
export function getBuyCheck(params) {
  return axios({
    url: '/lesson/lesson/getBuyCheck',
    method: 'get',
    params
  })
}
// 获取满意度信息
export function getTextbookSatisfactionH5(params) {
  return axios({
    url: '/textbook/textbook/getTextbookSatisfactionH5',
    method: 'post',
    data: qs.stringify(params)
  })
}

// 是否已经评价过
export function isAddComment(params) {
  return axios({
    url: '/lesson/lesson/isAddComment',
    method: 'get',
    params
  })
}
